/** @jsxImportSource @emotion/react */
"use client";

import type { HallowElementProps } from "@packages/ui";
import { constantSemanticColors, MoveIcon } from "@packages/ui";
import { forwardRef } from "react";

export type QueueHandleProps = HallowElementProps<"button">;

export const QueueHandle = forwardRef<HTMLButtonElement, QueueHandleProps>(
  (props, ref) => (
    <button ref={ref} onClick={(e) => e.stopPropagation()} {...props}>
      <MoveIcon color={constantSemanticColors.onColorVeryHigh} />
    </button>
  ),
);

QueueHandle.displayName = "QueueHandle";
